import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TAG_COLORS } from '@/shared/components/tag/tagColors';

const ColorSwatchPicker = ({ value, onChange, colors, getLabel, disabled }) => (
  <div className="color-swatch-picker">
    {colors.map(({ value: colorValue, key }) => (
      <button
        key={key}
        type="button"
        disabled={disabled}
        className={classNames('color-swatch', `color-swatch-${key}`, {
          selected: value === colorValue,
        })}
        title={getLabel ? getLabel(key) : undefined}
        onClick={() => onChange(colorValue)}
      >
        {value === colorValue && <i className="fa fa-check" aria-hidden="true" />}
      </button>
    ))}
  </div>
);

ColorSwatchPicker.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  colors: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      key: PropTypes.string.isRequired,
    }),
  ),
  getLabel: PropTypes.func,
  disabled: PropTypes.bool,
};

ColorSwatchPicker.defaultProps = {
  value: undefined,
  colors: TAG_COLORS,
  getLabel: undefined,
  disabled: false,
};

export default ColorSwatchPicker;
